/**
 * Keeps the "SKU below title" element (added in req #14) in sync with the
 * currently selected variant.
 *
 * Why this exists: the theme's product-info.js variant-change handler only
 * refreshes elements with ID "Sku-{sectionId}". Our element uses the
 * data-attribute selector instead and has no such ID, so it would otherwise
 * stay frozen on the default variant's SKU.
 *
 * Strategy: subscribe to PUB_SUB_EVENTS.variantChange (broadcast by
 * product-info.js after each variant switch) and pull the new SKU off the
 * variant payload. Falls back to scraping the freshly-fetched HTML the
 * theme passes in the event in case the variant object lacks `sku`.
 */
(function () {
  function update(target, sku) {
    if (!target) return;
    if (sku && sku.length > 0) {
      target.textContent = 'SKU: ' + sku;
      target.style.display = '';
    } else {
      // No SKU on the new variant — hide rather than show "SKU: undefined"
      target.style.display = 'none';
    }
  }

  function init() {
    const target = document.querySelector('[data-product-sku-after-title]');
    if (!target) return;

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      // pubsub isn't available — listen for the older 'variant:change' DOM event as fallback
      document.addEventListener('variant:change', (event) => {
        const variant = event.detail?.variant;
        if (variant) update(target, variant.sku);
      });
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, (eventData) => {
      const variant = eventData?.data?.variant;
      let sku = variant?.sku;

      if (sku === undefined || sku === null) {
        // Fall back to scraping the rendered HTML from the event payload —
        // product-info.js fetched a fresh section for the new variant; the
        // built-in SKU block (id="Sku-{sectionId}") will reflect the new value.
        const html = eventData?.data?.html;
        if (html) {
          const fresh = html.querySelector('[data-product-sku-after-title]')
                    || html.querySelector('.product__sku-after-title')
                    || html.querySelector('[id^="Sku-"]');
          if (fresh) {
            // For the fallback element the text is just the SKU value; for
            // ours it's "SKU: <value>". Strip our prefix if present.
            sku = fresh.textContent.trim().replace(/^SKU:\s*/i, '');
          }
        }
      }

      update(target, sku);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
